import Swiper from "swiper/bundle";

const swiperConfigs = {
  banner: {
    el: ".swiper--banner",
    config: {
      slidesPerView: "auto",
      spaceBetween: 45,
      centeredSlides: true,
      loop: true,
      autoplay: {
        deley: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
  card: {
    el: ".swiper--card",
    config: {
      slidesPerView: "auto",
      spaceBetween: 50,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination--num",
        type: "bullets",
        clickable: true,
        renderBullet: (index, className) => {
          if (index >= 9) {
            return `<span class="${className}">${index + 1}</span>`;
          }
          return `<span class="${className}">` + `0${index + 1}</span>`;
        },
      },
    },
  },
  aicases: {
    el: ".swiper--aicases",
    config: {
      slidesPerView: "auto",
      spaceBetween: 40,
      centeredSlides: true,
      loop: true,
      autoplay: false,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
  library: {
    el: ".swiper--library",
    config: {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 2,
        },
      },
    },
  },
  process: {
    el: ".swiper--process",
    config: {
      slidesPerView: "auto",
      spaceBetween: 40,
      centeredSlides: true,
      grabCursor: true,
      loop: true,
      threshold: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: false,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
  homehero: {
    el: ".swiper--home-hero",
    config: {
      slidesPerView: "1",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
      },
    },
  },
  events: {
    el: ".swiper--home-event",
    config: {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: false,
      breakpoints: {
        // 576px and up
        576: {
          slidesPerView: 2.25,
        },
        // 1400px and up
        1400: {
          slidesPerView: 2.5,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
  cases: {
    el: ".swiper--home-case-studies",
    config: {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: false,
      breakpoints: {
        // 576px and up
        576: {
          slidesPerView: 2.25,
        },
        // 1400px and up
        1400: {
          slidesPerView: 2.5,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
};

const initSwipers = () => {
  Object.values(swiperConfigs).forEach(({ el, config }) => {
    const swiperElement = document.querySelector(el);
    if (!swiperElement) return;
    // Check if this is the home case studies swiper and if it has 2 or fewer slides
    let modifiedConfig = config;
    if (el === ".swiper--home-case-studies" || el === ".swiper--home-event") {
      const slides = swiperElement.querySelectorAll(".swiper-slide");
      if (slides.length <= 2) {
        modifiedConfig = {
          ...config,
          loop: false,
          pagination: {
            enabled: false,
          },
          navigation: {
            enabled: false,
          },
        };
        
        // Hide navigation elements
        const navNext = swiperElement.querySelector('.swiper-button-next');
        const navPrev = swiperElement.querySelector('.swiper-button-prev');
        if (navNext) navNext.style.display = 'none';
        if (navPrev) navPrev.style.display = 'none';
        
        // Hide pagination element
        const pagination = swiperElement.querySelector('.swiper-pagination');
        if (pagination) pagination.style.display = 'none';
      }
    }

    const swiper = new Swiper(el, modifiedConfig);

    // Add event listener for certified-master-process buttons
    const buttons = document.querySelectorAll(".cmp-slider-button-wrapper a");

    // Only proceed if the buttons exist on the page
    if (buttons.length > 0) {
      buttons.forEach((button, index) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();

          // Change the swiper slide
          swiper.slideTo(index + 3);
        });
      });

      // Add event listener for swiper slide change to update active button
      swiper.on("slideChange", () => {
        // Remove 'active' class from all buttons
        buttons.forEach((btn) => btn.classList.remove("active"));

        // Add 'active' class to the button corresponding to the current slide
        if (swiper.activeIndex === 6) {
          buttons[0].classList.add("active");
        } else if (swiper.activeIndex === 2) {
          buttons[2].classList.add("active");
        } else if (
          swiper.activeIndex - 3 >= 0 &&
          swiper.activeIndex - 3 < buttons.length
        ) {
          buttons[swiper.activeIndex - 3].classList.add("active");
        }
      });
    }
  });
};

export default initSwipers;
